import fstDb from "../../../../../api/firebase/firestore/utils";
import { fetchEventTypes } from "../../dataCenter/helper";
import Act from "../../../../../store/actions";

const setLoading = (dispatch, isLoading) => {
  dispatch({
    type: Act.SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING,
    payload: isLoading,
  });
};

export const createCustomEvents = async (dispatch, user, customEvents) => {
  setLoading(dispatch, true);
  try {
    await fstDb.createEvents(user.uid, customEvents);
    await fetchEventTypes(user, dispatch);
  } catch (e) {
    console.log("Error creating events:", e);
  } finally {
    setLoading(dispatch, false);
  }
};

export const readCustomEvents = async (uid) => {
  try {
    const response = await fstDb.readEvents(uid);
    return response?.data?.events;
  } catch (e) {
    console.log("Error reading events:", e);
    return [];
  }
};

export const updateCustomEvents = async (
  dispatch,
  user,
  evtTypeId,
  updateData
) => {
  setLoading(dispatch, true);
  try {
    await fstDb.updateEvents(user.uid, evtTypeId, {
      name: updateData,
      label: updateData,
    });
    await fetchEventTypes(user, dispatch);
  } catch (e) {
    console.log("Error updating event:", e);
  } finally {
    setLoading(dispatch, false);
  }
};

export const deleteCustomEvents = async (dispatch, user, evtTypeIds) => {
  setLoading(dispatch, true);
  try {
    await fstDb.deleteEvents(user.uid, evtTypeIds);
    await fetchEventTypes(user, dispatch);
  } catch (err) {
    console.log("Unexpected error:", err);
  } finally {
    setLoading(dispatch, false);
  }
};
